
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class RejectionBOMGrid extends Serenity.EntityGrid<RejectionBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.RejectionBOM'; }
        protected getDialogType() { return RejectionBOMDialog; }
        protected getIdProperty() { return RejectionBOMRow.idProperty; }
        protected getInsertPermission() { return RejectionBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return RejectionBOMRow.localTextPrefix; }
        protected getService() { return RejectionBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}